/**
 * System number separators for the current locale (decimal and thousand).
 * Used so currency/number form fields display and accept input using the user's
 * system conventions (e.g. comma vs period as decimal separator).
 * Ensures decimal and thousand separators are never equal.
 */
export function getSystemNumberSeparators(): { decimalSeparator: string; thousandSeparator: string } {
  try {
    const lang = (navigator.language === 'en-ZA' ? 'en-GB' : navigator.language) || 'en-GB';
    const formatter = new Intl.NumberFormat(lang);
    const parts = formatter.formatToParts(1234.5);
    let decimal = parts.find((p) => p.type === 'decimal')?.value ?? '.';
    let thousand = parts.find((p) => p.type === 'group')?.value ?? ',';
    if (decimal === thousand) {
      if (decimal === ',') {
        thousand = '.';
      } else {
        thousand = ',';
      }
    }
    return { decimalSeparator: decimal, thousandSeparator: thousand };
  } catch {
    return { decimalSeparator: '.', thousandSeparator: ',' };
  }
}
